import type { RegistrationPaymentStatus } from '../types';

/**
 * User-facing names for a registration's payment status.
 * The stored value and the API stay `rejected`.
 */
export const PAYMENT_STATUS_LABELS: Record<RegistrationPaymentStatus, string> = {
  not_required: 'No payment',
  pending: 'Pending',
  verified: 'Verified',
  rejected: 'Cancelled',
};

/** Member-facing wording for the same stored statuses. */
export const MY_PAYMENT_STATUS_LABELS: Record<RegistrationPaymentStatus, string> = {
  not_required: 'Confirmed',
  pending: 'Payment under review',
  verified: 'Payment verified',
  rejected: 'Payment cancelled',
};

/** Screenshot viewer action that sets the stored status to `rejected`. */
export const CANCEL_PAYMENT_BUTTON_LABEL = 'Cancel payment';

export function cancelPaymentConfirm(regNumber: string, name: string): string {
  return `Mark the payment for ${regNumber} (${name}) cancelled?`;
}

export const CANCELLED_PAYMENT_MEMBER_NOTE =
  'Your payment was cancelled. Please contact the event coordinator.';
